import { SwitchField } from '@dev-spendesk/grapes';

import {
  useTranslation,
  type TGlobalFunctionTyped,
} from 'src/core/common/hooks/useTranslation';

import { type Dimension } from '../../approvalWorkflow';

type Props = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  dimensionName: Dimension['type'];
  isChecked: boolean;
  valueFieldName?: string;
};

export const ApplyToAllSwitchField = ({
  onChange,
  isChecked,
  dimensionName,
  valueFieldName,
}: Props) => {
  const { t } = useTranslation('global');
  return (
    <SwitchField
      fit="parent"
      className="mt-8"
      label={getFieldLabel(dimensionName, t, valueFieldName)}
      helpText={getFieldHelpText(dimensionName, t, valueFieldName)}
      isChecked={isChecked}
      onChange={onChange}
    />
  );
};

const getFieldLabel = (
  dimensionName: string,
  t: TGlobalFunctionTyped,
  valueFieldName?: string,
) => {
  switch (dimensionName) {
    case 'spendType':
      return t(
        'approvalWorkflows.dimensions.spendType.applyToAllOtherSpendTypes',
      );
    case 'team':
      return t('approvalWorkflows.dimensions.team.applyToAllOtherTeams');
    case 'costCenter':
      return t(
        'approvalWorkflows.dimensions.costCenter.applyToAllOtherCostCenters',
      );
    case 'customField':
      return t(
        'approvalWorkflows.dimensions.customField.applyToAllOtherCustomFields',
        { customField: valueFieldName },
      );
    case 'expenseCategory':
      return t(
        'approvalWorkflows.dimensions.expenseCategory.applyToAllOtherExpenseCategories',
      );
    default:
      return '';
  }
};

const getFieldHelpText = (
  dimensionName: string,
  t: TGlobalFunctionTyped,
  valueFieldName?: string,
) => {
  switch (dimensionName) {
    case 'spendType':
      return t(
        'approvalWorkflows.dimensions.spendType.allOtherNewSpendTypesWillFollowThisApprovalWorkflow',
      );
    case 'team':
      return t(
        'approvalWorkflows.dimensions.team.allOtherNewTeamsWillFollowThisApprovalWorkflow',
      );
    case 'costCenter':
      return t(
        'approvalWorkflows.dimensions.costCenter.allOtherNewCostCentersWillFollowThisApprovalWorkflow',
      );
    case 'customField':
      return t(
        'approvalWorkflows.dimensions.customField.allOtherNewCustomFieldsWillFollowThisApprovalWorkflow',
        { customField: valueFieldName },
      );
    case 'expenseCategory':
      return t(
        'approvalWorkflows.dimensions.expenseCategory.allOtherNewExpenseCategoriesWillFollowThisApprovalWorkflow',
      );
    default:
      return '';
  }
};
